import './scss/style.scss';
import { initSpecialSwiper } from './ts/special-swiper';
import { initNav } from './ts/nav';
import { initModal } from './ts/modal';
import { initScrollAnimation } from './ts/scroll-animation';

initSpecialSwiper();
initNav();
initModal();
initScrollAnimation();
